import BaseModel from "./BaseModel";
import Company from "./Company";
import User from "./User";
import UserDocuments from "./UserDocuments";
import UserSubscriptions from "./UserSubscriptions";
import Order from "./Order";
import UserOrders from "./UserOrders";

export default class Invoice extends BaseModel {
  static entity = "invoices";
  static primaryKey = "id";

  static fields() {
    return {
      company: this.belongsTo(Company, "company_id"),
      company_id: this.number(0),
      created_at: this.attr(""),
      finalized_at: this.attr(null),
      hosted_invoice_url: this.attr(null),
      id: this.number(0),
      invoiceable_id: this.attr(null),
      invoiceable_type: this.string(""),
      marked_uncollectible_at: this.attr(null),
      number: this.attr(null),
      paid_at: this.attr(null),
      payment_intent: this.string(null).nullable(),
      payment_intent_client_secret: this.string(null).nullable(),
      status: this.string(""),
      stripe_id: this.string(""),
      tax: this.attr(null),
      total: this.number(0),
      updated_at: this.attr(""),
      user: this.belongsTo(User, "user_id"),
      user_id: this.number(0),
      voided: this.attr(null),
    };
  }

  static async $create(request_params) {
    const response = await this.axios.post(`/${this.entity}`, request_params);
    if (response.data?.invoice) {
      await this.create({ data: response.data.invoice });
      await this.updateInvoiceable(response.data);
    }
    return response;
  }
  // Live sales tax estimate for a cart, document or plan. Each call is a Stripe
  // Tax calculation, so callers debounce it and send only complete addresses.
  static async estimateTax(params) {
    const { data } = await this.axios.post("/tax/estimates", params);
    return data;
  }
  static async updateInvoiceable(data) {
    switch (data.invoiceable_type) {
      case "Document":
        await UserDocuments.update({
          where: data.invoiceable.id,
          data: { ...data.invoiceable },
        });
        break;
      case "Subscription":
        await UserSubscriptions.update({
          where: data.invoiceable.id,
          data: { ...data.invoiceable },
        });
        if (data.document) {
          await UserDocuments.update({
            where: data.document.id,
            data: { ...data.document },
          });
        }
        break;
      case "Order":
        await Order.update({
          where: data.invoiceable.id,
          data: { ...data.invoiceable },
        });
        await UserOrders.update({
          where: data.invoiceable.id,
          data: { ...data.invoiceable },
        });
        break;
    }
  }
}
